var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0.127956C16.55 0.127956 17.0208 0.322304 17.4125 0.711C17.8042 1.0997 18 1.56696 18 2.11279V16.0066C18 16.5525 17.8042 17.0197 17.4125 17.4084C17.0208 17.7971 16.55 17.9915 16 17.9915H9V16.0066H16V2.11279H9V0.127956H16ZM5 4.09762L6.375 5.53663L3.825 8.06729H12V10.0521H3.825L6.375 12.5828L5 14.0218L0 9.05971L5 4.09762Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.96bac43aa01f5d8b3560e30a16b2bd5a.svg";
export { ForwardRef as ReactComponent };